import {
  WEB_API_GET_DOCUMENTS,
  WEB_API_GET_DOCUMENT_BY_ID,
  WEB_API_GET_DOC_GLOSSARY_BY_ID,
  WEB_API_GET_RELATED_DOCS_BY_ID,
  WEB_API_GET_RELATED_SECTION_BY_ID,
  WEB_API_GET_SECTIONS_BY_ID,
  WEB_API_GET_SECTION_BY_PAGE_ID,
  WEB_API_GET_SUMMARY_BY_DOC_ID,
  WEB_API_LOADING,
} from './webApiTypes';

const initialState = {
  loading: false,
  documents: null,
  document: null,
  sections: null,
  relatedDocs: null,
  glossary: null,
  pageSection: null,
  relatedSections: null,
  summary: null,
};

const WebApiReducer = (state = initialState, action) => {
  switch (action.type) {
    case WEB_API_LOADING:
      return {
        ...state,
        loading: true,
      };
    case WEB_API_GET_DOCUMENTS:
      return {
        ...state,
        documents: action.payload,
        loading: false,
      };
    case WEB_API_GET_DOCUMENT_BY_ID:
      return {
        ...state,
        document: action.payload,
        loading: false,
      };
    case WEB_API_GET_SECTIONS_BY_ID:
      return {
        ...state,
        sections: action.payload,
        loading: false,
      };
    case WEB_API_GET_RELATED_DOCS_BY_ID:
      return {
        ...state,
        relatedDocs: action.payload,
        loading: false,
      };
    case WEB_API_GET_DOC_GLOSSARY_BY_ID:
      return {
        ...state,
        glossary: action.payload,
        loading: false,
      };
    case WEB_API_GET_SECTION_BY_PAGE_ID:
      return {
        ...state,
        pageSection: action.payload,
        loading: false,
      };
    case WEB_API_GET_RELATED_SECTION_BY_ID:
      return {
        ...state,
        relatedSections: action.payload,
        loading: false,
      };
    case WEB_API_GET_SUMMARY_BY_DOC_ID:
      return {
        ...state,
        summary: action.payload,
        loading: false,
      };

    default:
      return { ...state };
  }
};

export default WebApiReducer;
